import {testIdProps} from '@github-ui/test-id-props'

import type {NumericValue} from '../../../api/columns/contracts/number'
import {type ColumnValue, isEmpty, isLoading} from '../../../models/column-value'
import type {MemexItemModel} from '../../../models/memex-item-model'
import {TextPlaceholder} from '../../common/placeholders'
import {BaseCell} from '../cells/base-cell'
import {TextCell} from '../cells/text-cell'
import {useRecordCellRenderer} from '../performance-measurements'
import {withCellRenderer} from './cell-renderer'
import styles from './number-renderer.module.css'

type Props = Readonly<{
  currentValue: ColumnValue<NumericValue>
  model: MemexItemModel
  isDisabled?: boolean
}>

export const LoadingNumberCell = () => (
  <BaseCell className={styles.BaseCell}>
    <TextPlaceholder minWidth={20} maxWidth={30} {...testIdProps('placeholder')} />
  </BaseCell>
)

export const NumberRenderer = withCellRenderer<Props>(function NumberRenderer({currentValue, model, isDisabled}) {
  useRecordCellRenderer('NumberRenderer', model.id)

  if (isLoading(currentValue)) {
    return <LoadingNumberCell />
  }

  if (isEmpty(currentValue)) {
    return null
  }

  return (
    <BaseCell className={styles.BaseCell}>
      <TextCell dangerousHtml={currentValue.value.value.toString()} isDisabled={isDisabled} />
    </BaseCell>
  )
})

NumberRenderer.displayName = 'NumberRenderer'

try{ LoadingNumberCell.displayName ||= 'LoadingNumberCell' } catch {}